import {
	MimaButton,
	MimaDropdown,
	MimaInput,
	MimaText,
	Modal,
	PageLoader,
} from '../../components';
import styles from '../../assets/styles/Settings/Settings.module.scss';
import React, { useState } from 'react';
import OtpInput from 'react-otp-input';
import { Formik } from 'formik';

const WithdrawalAccount = ({
	closeModal,
	setAccountName,
	accountName,
	banks,
	stage2,
	loading,
	setLoading,
	onSubmit,
	onSubmitPIN,
	validationSchema,
	verifyAccountNumber,
}) => {
	const [otp, setOtp] = useState('');

	return (
		<Modal closeModal={closeModal} goBack={closeModal}>
			<>
				<MimaText variant="subtitle" mb={3}>
					Withdrawal Account
				</MimaText>

				{!stage2 && (
					<div>
						<MimaText mb={3} color="var(--color-primary)" align="center">
							Create withdrawal Account
						</MimaText>
						<Formik
							initialValues={{
								bankCode: '',
								bank: '',
								accountNumber: '',
							}}
							validationSchema={validationSchema}
							onSubmit={onSubmit}
						>
							{({
								handleChange,
								handleBlur,
								handleSubmit,
								values,
								errors,
								touched,
								setFieldValue,
							}) => (
								<>
									<div className={styles.bus__details}>
										<MimaDropdown
											labelTitle="Bank Name"
											placeholder="-Select-"
											data={banks}
											id="bankCode"
											onChange={data => {
												setFieldValue('bankCode', data.id);
												setFieldValue('bank', data.value);
											}}
											name="bankCode"
											onBlur={handleBlur}
											error={errors.bankCode}
											touched={touched.bankCode}
										/>
										<MimaInput
											type="text"
											labelTitle="Account Number"
											name="accountNumber"
											value={values.accountNumber}
											onChange={e => {
												setLoading(true);
												verifyAccountNumber({
													accountNumber: e.target.value,
													beneficiaryBank: values.bankCode,
												}).then(data => {
													setAccountName(data);
													setLoading(false);
												});
												handleChange(e);
											}}
											onBlur={handleBlur}
											error={errors.accountNumber}
											touched={touched.accountNumber}
										/>
										<MimaInput
											type="text"
											disabled={true}
											labelTitle="Account Name"
											name="accountName"
											value={accountName}
											placeholder={accountName}
											onChange={handleChange}
											onBlur={handleBlur}
										/>

										<MimaButton
											disabled={loading}
											loading={loading}
											title="Continue"
											type="submit"
											onClick={handleSubmit}
										/>
									</div>
								</>
							)}
						</Formik>
					</div>
				)}

				{stage2 && (
					<Formik
						initialValues={{
							otp: '',
						}}
						onSubmit={onSubmitPIN}
					>
						{() => (
							<div className={styles.pin}>
								{loading ? (
									<PageLoader title="Processing" loading={loading} />
								) : (
									<>
										<form onSubmit={onSubmitPIN}>
											<MimaText
												mb={3}
												color="var(--color-primary)"
												align="center"
											>
												Enter your pin to complete withdrawal account set up
											</MimaText>
											<MimaText variant="small" ml={6}>
												Enter Pin
											</MimaText>
											<OtpInput
												value={otp}
												onChange={otp => {
													setOtp(otp);
													if (otp >= 1000) {
														onSubmitPIN(otp);
													}
												}}
												numInputs={4}
												isInputSecure={true}
												inputStyle={{
													fontSize: '2.4rem',
													fontFamily: 'inherit',
													width: '6rem',
													height: '6rem',
													margin: '.4rem',
													borderTop: '0px',
													border: '1px solid #4A4A68',
													borderRadius: '1rem',
													display: 'block',
													outline: 'none',
													textAlign: 'center',
													marginRight: '2rem',
												}}
												isInputNum
											/>
										</form>
									</>
								)}
							</div>
						)}
					</Formik>
				)}
			</>
		</Modal>
	);
};

export default WithdrawalAccount;
